import { useErrorPageMeta } from '../../../hooks/usePageMeta'
import { ERROR_META } from '../../../utils/pageMeta'

/**
 * Minimal fallback used by the OUTERMOST ErrorBoundary in App.tsx.
 *
 * It renders only when something catastrophic crashes ABOVE the Layout
 * (Provider / Router / Layout itself). For all normal page-level errors,
 * the inner ErrorBoundary catches them and the regular ErrorFallback runs
 * inside the live Layout (header, navigation, footer remain visible).
 *
 * S3 always serves this SPA as HTTP 200, so the fallback must set an honest
 * title and noindex. Otherwise the homepage snippet is indexed on the error URL.
 */
export default function RootErrorFallback() {
  useErrorPageMeta(ERROR_META.title, ERROR_META.description)
  const handleReload = () => {
    window.location.href = '/'
  }

  return (
    <div
      role="alert"
      aria-live="assertive"
      style={{
        minHeight: '60vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 16,
        padding: 24,
        fontFamily: 'system-ui, -apple-system, "Inter18pt-Regular", sans-serif',
        color: '#111',
        background: '#fff',
        textAlign: 'center',
      }}
    >
      <p style={{ margin: 0, fontSize: 16, fontWeight: 500 }}>{ERROR_META.title}</p>
      <p style={{ margin: 0, fontSize: 14, color: '#666' }}>
        Спробуйте оновити сторінку або повернутися на головну.
      </p>
      <button
        type="button"
        onClick={handleReload}
        style={{
          padding: '10px 20px',
          border: '1px solid #000',
          borderRadius: 999,
          background: 'transparent',
          fontSize: 14,
          cursor: 'pointer',
        }}
      >
        На головну
      </button>
    </div>
  )
}
